import { useRef, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import Header from "../../component/Header";
import TicketsTable from "../Reports/TicketsReports";
import InProgressReport from "../Reports/InProgressReport";
import ReOpenedReport from "../Reports/ReOpenedReport";
import EscalatedReport from "../Reports/EscalatedReport";
import ClosedReport from "../Reports/ClosedReport";
import CustomersReport from "../Reports/CutomerReports";

import utils from "../../utils/utils";
import { useAuth } from "../../context/AuthContext";

export default function Reports() {
  const { authUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const isFieldAssist =
    authUser?.isAdmin === false &&
    authUser?.Agents_Company?.trim() === "Field Assist";

const isSpecialCompany =
  ["Gulf Oil", "Global Software" , "Global Gulf Support" ].includes(
    authUser?.Agents_Company?.trim()
  );
  
  // Tabs depending on user type
  const allTabs = isSpecialCompany
    ?[
        "All Tickets",
        "In Progress Tickets",
        "Reopen Tickets",
        "Closed Tickets",
        "My Tickets"
      ]
    : [
        "All Tickets",
        "In Progress Tickets",
        "Reopen Tickets",
        "Closed Tickets"
      ];

  // Read tab query param
  const searchParams = new URLSearchParams(location.search);
  const initialTab = searchParams.get("tab");

  // Initial tab state
  const [selectedTab, setSelectedTab] = useState(
    allTabs.includes(initialTab) ? initialTab : allTabs[0]
  );

  const indicatorRef = useRef(null);
  const buttonsRef = useRef([]);

  useEffect(() => {
    let url = window.location.search?.split("?")[1];
    let splittedData = url?.split("&");
    let filterId = splittedData?.length
      ? splittedData[1]?.split("=")[1]
      : "";

    // Apply filterId only if not Gulf Oil
    if (!isSpecialCompany && filterId) {
      if (filterId == 1) {
        setSelectedTab("In Progress Tickets");
      } else if (filterId == 4) {
        setSelectedTab("Closed Tickets");
      } else if (filterId == 2) {
        setSelectedTab("Reopen Tickets");
      } else if (filterId == 5) {
        setSelectedTab("All Tickets");
      }
    }

    // Redirect if current tab not allowed
    if (!allTabs.includes(selectedTab)) {
      setSelectedTab(allTabs[0]);
    }

    // Update indicator
    const index = allTabs.indexOf(selectedTab);
    const button = buttonsRef.current[index];
    if (button && indicatorRef.current) {
      indicatorRef.current.style.width = `${button.offsetWidth}px`;
      indicatorRef.current.style.transform = `translateX(${button.offsetLeft}px)`;
    }
  }, [selectedTab, allTabs, isSpecialCompany]);

  useEffect(() => {
    utils.saveRecentSearch("Report", window.location.pathname);
  }, []);

  const renderContent = () => {
    if (isFieldAssist) {
      return <EscalatedReport />;
    }
    switch (selectedTab) {
      case "All Tickets":
        return <TicketsTable />;
      case "In Progress Tickets":
        return <InProgressReport />;
      case "Reopen Tickets":
        return <ReOpenedReport />;
      case "Closed Tickets":
        return <ClosedReport />;
      case "My Tickets":
        return <CustomersReport />;
      default:
        return null;
    }
  };

  const redirectToMainPage = (label) => {
    navigate("/reports");
    setSelectedTab(label);
  };

  return (
    <div className="dashboard">
      <Header title subtitle="Reports" searchbar />
      <div className="center-content">
        <div className="container">
          <div className="pagegap d-flex flex-column">
            <div className="tab-wrapper position-relative">
              <div className="tab-indicator" ref={indicatorRef}></div>

              {allTabs.map((label, index) => (
                <button
                  key={label}
                  className={`tab-button ${selectedTab === label ? "active" : ""}`}
                  onClick={() => redirectToMainPage(label)}
                  ref={(el) => (buttonsRef.current[index] = el)}
                >
                  {label}
                </button>
              ))}
            </div>

            <AnimatePresence mode="wait">
              <motion.div
                key={selectedTab}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.3 }}
              >
                {renderContent()}
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </div>
  );
}
